<template>
  <div class="content">
    <div class="row">
      <!--      <div class="col-sm-3">-->
      <!--        <ArtistSelect @unitChangeEvent="getArtistInfo" :show-all-units="true" :is-filter="false" :show-members="false" :initial-unit-id="0" />-->
      <!--      </div>-->
      <div class="col-sm-12 d-flex align-items-center gap-2">
        <div class="row">
          <div class="col-sm-12"></div>
          <base-button class="update-button" @click.prevent="goCategoryForm()" type="success" style="padding: 24px 64px; font-size: 14px"
            >카테고리추가</base-button
          >
          <base-button class="update-button" @click.prevent="updateCategoryOrder" type="primary" style="padding: 24px 64px; font-size: 14px"
            >순서정렬</base-button
          >
        </div>
      </div>
    </div>

    <table class="table table-bordered" style="width: 100%">
      <thead>
        <tr>
          <th style="width: 100px; text-align: center">정렬</th>
          <th style="width: 100px; text-align: center">ID</th>
          <th style="text-align: center">카테고리</th>
          <th style="width: 200px; text-align: center">작업</th>
        </tr>
      </thead>
      <draggable tag="tbody" v-model="data" handle=".drag-handle" :animation="200">
        <tr v-for="element in data" :key="element.id">
          <td align="center"><span class="drag-handle" style="cursor: move">☰</span></td>
          <td align="center">{{ element.id }}</td>
          <td>{{ element.title }}</td>
          <td align="center">
            <el-button size="mini" type="warning" @click="goCategoryForm(element.id)">수정</el-button>
            <el-button size="mini" v-if="!element.hasQuest" type="danger" @click="removeCategory(element.id)">삭제</el-button>
          </td>
        </tr>
      </draggable>
    </table>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import draggable from "vuedraggable";
import swal from "sweetalert2";

export default {
  components: {
    ArtistSelect,
    draggable,
  },
  async created() {
    await this.getData();
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;

      await this.getData();
    },
    async getData() {
      const res = await this.$axios.get(`/quests/categories`);
      this.data = res.data.data;
    },

    async goCategoryForm(id) {
      if (id) {
        await this.$router.push(`/quest/categoryForm?id=${id}&unitId=${this.unitId}`);
      } else {
        await this.$router.push(`/quest/categoryForm?unitId=${this.unitId}`);
      }
    },

    async removeCategory(id) {
      const result = await swal.fire({
        title: "카테고리 삭제 확인",
        text: "정말로 이 카테고리를 삭제하시겠습니까?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "삭제",
        cancelButtonText: "취소",
        customClass: {
          confirmButton: "btn btn-danger btn-fill",
          cancelButton: "btn btn-cancel btn-fill",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        await this.$axios.delete(`/quests/categories/${id}`);
        await this.getData();
      }
    },

    async updateCategoryOrder() {
      const ids = this.data.map((item) => item.id);
      await this.$axios.put("/quests/categories/order", { ids });
      Toast.success("정렬되었습니다");
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
.category-row {
  border-bottom: 1px solid #ccc;
}
.category-row[data-row-key][style*="background-color: rgb(211, 211, 211)"] {
  background-color: #d3d3d3 !important;
}
.drag-handle {
  cursor: move;
}
</style>
